export const items: Array<IItemType> = [
{
    id: 1,
    caption: 'Getting started',
    iconName: "hourglass-start",
    subItems: [{
        id:1,
        caption: 'What is already set up',
        iconName: "laptop",
       
    },
    {
        id:2,
        caption: 'Account activation as a primary/secondary administrator',
        iconName: "sign-in",
        
    },
    {
        id:3,
        caption: 'Account validation as a standard user',
        iconName: "user-circle",
       
    },
    {
        id:4,
        caption: 'Log on',
        iconName: "user",
        subItems: [{
            id:1,
            caption: 'How to log on to Gem Connect',
            iconName: "user-circle",
        },
        {
            id:2,
            caption: 'How to log on to Gem Connect for the first time as a primary admin user',
            iconName: "user-circle",
        },]
       
    },
  
    {
        id:5,
        caption: 'Log out',
        iconName: "user-times",
        subItems: [{
            id:1,
            caption: 'How to log out of Gem Connect',
            iconName: "times-circle",
        },
        {
            id:2,
            caption: 'Site time-out',
            iconName: "outdent",
        },]
       
    }
    
    ]
},
{
    id: 2,
    caption: 'Role profiles and user set up',
    iconName: "users",
    linkName: 'roleProfilesUsersSetup',
    subItems: [{
        id:1,
        caption: 'Role profiles and users',
        iconName: "user",
        linkName: "setupActivityRoleProfileUser",
        subItems: [
            {
                id:1,
                caption: 'Add user role profile',
                iconName: "plus-circle"
            },
            {
                id:2,
                caption: 'Manage user role profile',
                iconName: "tasks",
                subItems: [
                    {
                        id:1,
                        caption: 'Edit user role profile',
                        iconName: "edit"
                    },
                    {
                        id:2,
                        caption: 'Delete user role profile',
                        iconName: "user-times"
                    },
                    {
                        id:3,
                        caption: 'View user role profile',
                        iconName: "eye"
                    },
                    {
                        id:4,
                        caption: 'Clone',
                        iconName: "clone"
                    },
                    {
                        id:5,
                        caption: 'List users',
                        iconName: "list"
                    }
                ]
            }
        ]
    },
    {
        id:2,
        caption: 'Create users',
        iconName: "user-plus",        
        subItems: [{
            id:1,
            caption: 'Create individual user',
            iconName: "user",
        },
        {
            id:2,
            caption: 'Create multiple users',
            iconName: "users",
        },]
    },
    {
        id:3,
        caption: 'Manage users',
        iconName: "tasks",
        subItems: [
            {
                id:1,
                caption: 'Search users',
                iconName: "search"
            },
            {
                id:2,
                caption: 'Edit users',
                iconName: "edit"
            },
            {
                id:3,
                caption: 'Activate users',
                iconName: "play-circle"
            },
            {
                id:4,
                caption: 'Suspend and reactivate users',
                iconName: "unlock"
            },
            {
                id:5,
                caption: 'Manage security settings',
                iconName: "shield",
                subItems: [
                    {
                        id:1,
                        caption: 'Reset user’s telephony PIN',
                        iconName: "tty"
                    },
                    {
                        id:2,
                        caption: 'Unlock user',
                        iconName: "unlock"
                    },
                    {
                        id:3,
                        caption: 'Reset user’s password',
                        iconName: "repeat"
                    },
                    {
                        id:4,
                        caption: 'Reset user’s activation code',
                        iconName: "keyboard-o"
                    },
                    {
                        id:5,
                        caption: 'Manage user’s security cards',
                        iconName: "vcard"
                    }
                ]
            },
            {
                id:6,
                caption: 'Security device management',
                iconName: "mobile"
            }
        ]
    },
    {
        id:4,
        caption: 'System users',
        iconName: "user-secret",
        linkName: 'systemuser',
    }]
},
{
    id: 3,
    caption: 'Accounts functionality',
    menuCaption:'Accounts',
    iconName: "user-circle",
    subItems: [{
        id:1,
        caption: 'Accounts overview',
        iconName: "play-circle",
    },
    {
        id:2,
        caption: 'Multibank/shadow accounts',
        iconName: "bank",
    },
    {
        id:3,
        caption: 'Virtual accounts',
        iconName: "vcard",
        subItems: [
            {
                id: 1,
                caption: 'Virtual accounts overview and enablement',
                iconName: 'info-circle'
            },
            {
                id: 2,
                caption: 'Virtual account entitlements',
                iconName: 'id-card'
            },
            {
                id: 3,
                caption: 'Create virtual accounts',
                iconName: 'plus'
            },
            {
                id: 4,
                caption: 'Bulk creation/import of virtual accounts',
                iconName: 'plus-square',
                linkName: 'massCreationImportVirtualAccs'
            },
            {
                id: 5,
                caption: 'Edit virtual accounts and hierarchy',
                iconName: 'sitemap'
            },
            {
                id: 6,
                caption: 'Virtual account payments',
                iconName: 'credit-card'
            },
            {
                id: 7,
                caption: 'Virtual account custom routing rules',
                iconName: 'code-fork',
                linkName: 'customRoutingRules'
            },
            {
                id: 8,
                caption: 'Virtual suspense account transaction assignment',
                iconName: 'arrows-h',
                linkName: 'suspenseAccountTransactionAssignment'
            },
            {
                id: 9,
                caption: 'Virtual account reporting and statements',
                iconName: 'bar-chart'
            },
            {
                id: 10,
                caption: 'Virtual group interest and limits',
                iconName: 'group'
            },
            {
                id: 11,
                caption: 'Close Virtual Accounts',
                iconName: 'minus'
            }
        ]
    },
    {
        id:4,
        caption: 'Account view navigation',
        iconName: "sitemap",
    },
    {
        id:5,
        caption: 'Account management',
        iconName: "sliders",
    },
    {
        id:6,
        caption: 'Manage account groups',
        iconName: "users",
    },
    {
        id:7,
        caption: 'Transaction history',
        iconName: "history",
    },
    {
        id:8,
        caption: 'Group limits',
        iconName: "shield",
    }]
},
{
    id: 4,
    caption: 'Payments functionality',
    menuCaption:'Payments',
    iconName: "credit-card",
    linkName:"paymentsFunctionality",
    subItems: [{
        id:1,
        caption: 'Payment workflow & approval chain',
        iconName: "exchange",
        linkName:'PaymentWorkflowApprovalChain',
    },
    {
        id:2,
        caption: 'Payment approval groups',
        iconName: "group",
        linkName:"PaymentApprovalGroups",
    },
    {
        id:3,
        caption: 'Manage beneficiaries',
        iconName: "user-plus",
        linkName: "manageBeneficiaries"
    },
    {
        id:4,
        caption: 'Beneficiary user groups',
        iconName: "user-circle",
        linkName: "beneficiariesGroup"
    },
    {
        id:5,
        caption: 'Bank look up',
        iconName: "search",
    },
    {
        id:6,
        caption: 'Make a Faster Payment',
        iconName: "flash",
        linkName:"fasterpayments"
    },
    {
        id:7,
        caption: 'Make a BACS payment',
        iconName: "money",
    },
    {
        id:8,
        caption: 'Make a CHAPS payment',
        iconName: "credit-card-alt",
    },
    {
        id:10,
        caption: 'Make an international payment',
        iconName: "credit-card-alt",
    },
    {
        id:11,
        caption: 'Make a SEPA credit transfer',
        iconName: "credit-card",
    },
    {
        id:12,
        caption: 'SEPA direct debits',
        iconName: "credit-card",
    },
    {
        id:13,
        caption: 'Make a request for transfer',
        iconName: "arrows-h",
    },
    {
        id:14,
        caption: 'FI to FI transfers',
        iconName: "play-circle",
    },
    {
        id:15,
        caption: 'Inter-group transfers',
        iconName: "bank",
    },
    {
        id:22,
        caption: 'Make a recurring payment',
        iconName: "credit-card",
        linkName:'recurringPayments'
    },
    {
        id:16,
        caption: 'Payment summary',
        iconName: "check-circle",
    },
    {
        id:17,
        caption: 'Payment approvals',
        iconName: "check-circle",
    },
    {
        id:18,
        caption: 'Payment preferences',
        iconName: "gear",
        linkName: "paymentPreferencesSection",
    },
    {
        id:19,
        caption: 'Transaction upload',
        iconName: "upload",
        linkName:'transactionUpload'
    },
    {
        id:20,
        caption: 'Payment templates',
        iconName: "upload",
        linkName:'transactionUpload'
    },

    {
        id:21,
        caption: 'Ultimate debtor (POBO)',
        iconName: "credit-card",
        linkName:'ultimateDebator'
    }]
},
{
    id: 5,
    caption: 'Admin',
    iconName: "lock",
    subItems: [{
        id:1,
        caption: 'Summary',
        iconName: "drivers-license",
    },
    {
        id:2,
        caption: 'Administrators',
        iconName: "users",
    },
    {
        id:3,
        caption: 'Business partner (legal entity) information',
        iconName: "user-circle-o",
    },
    {
        id:4,
        caption: 'User workflow',
        iconName: "gg-circle",
    },
    {
        id:5,
        caption: 'Client report preferences (end of day or intraday statements)',
        iconName: "flag",
    }]
},

{
    id: 7,
    caption: 'Approvals',
    iconName: "check-square",
    subItems: [{
        id:1,
        caption: 'Pending approvals',
        iconName: "check-circle",
    },{
        id:2,
        caption: 'Where do I find approval items?',
        iconName: "check-circle", 
    }]
},
{
    id: 8,
    caption: 'Reports',
    iconName: "table",
    linkName: 'reports',
    subItems: [{
        id:1,
        caption: 'Information reporting',
        iconName: "area-chart",
    },
    {
        id:2,
        caption: 'Download legal bank statements',
        iconName: "list-alt",
    },
    {
        id:3,
        caption: 'Request end of day or intraday statements',
        iconName: "tablet",
    },
    {
        id:4,
        caption: 'User activity audit reports',
        iconName: "file-excel-o",
    }]
},
{
    id: 9,
    caption: 'Reference documentation',
    menuCaption:'More >>',
    iconName: "chevron-circle-down",
    linkName: "referenceDocumentation",
    subItems: [{
        id:1,
        caption: 'Screen resolution and \n systems compatibility',
        iconName: "laptop",
    },
    {
        id:2,
        caption: 'Glossary of terms',
        iconName: "globe",
    },
    {
        id:3,
        caption: 'Payment and currency cut-off times',
        iconName: "clock-o fa-flip-horizontal",
    },    
    {
        id:4,
        caption: 'Mandatory country information – international payments',
        iconName: "globe",
    },    
    {
        id:5,
        caption: 'Supported currencies',
        iconName: "money",
    },    
    {
        id:6,
        caption: 'File import guides',
        iconName: "book",
        subItems: [{
            id:1,
            caption: 'Transaction upload (payment import)',
            iconName: "money",
            subItems: [{
                id:1,
                caption: 'Guidance',
                iconName: "book",
            },
            {
                id:2,
                caption: 'CSV templates',
                iconName: "credit-card",
                subItems: [{
                    id:1,
                    caption: 'Bacs Payments',
                    iconName: "money",
                },
                {
                    id:2,
                    caption: 'Faster Payments',
                    iconName: "flash",
                },
                {
                    id:3,
                    caption: 'CHAPS Payments',
                    iconName: "credit-card-alt",
                },
                {
                    id:4,
                    caption: 'SEPA Credit Transfers',
                    iconName: "credit-card",
                },
                {
                    id:5,
                    caption: 'International Payments',
                    iconName: "globe",
                },
                {
                    id:6,
                    caption: 'Inter-group Transfers',
                    iconName: "bank",
                }]
            },
            {
                id:3,
                caption: 'CSV example files',
                iconName: "info-circle",
                subItems: [{
                    id:1,
                    caption: 'Bacs Payments (SDSC)',
                    iconName: "money",
                },
                {
                    id:2,
                    caption: 'Multiple Bacs Payments (SDMC)',
                    iconName: "exchange",
                },
                {
                    id:3,
                    caption: 'Faster Payments (SDSC)',
                    iconName: "flash",
                },
                {
                    id:4,
                    caption: 'Multiple Faster Payments (SDMC)',
                    iconName: "play-circle",
                },
                {
                    id:5,
                    caption: 'CHAPS Payments',
                    iconName: "credit-card-alt",
                },
                {
                    id:6,
                    caption: 'SEPA Credit Transfers',
                    iconName: "credit-card",
                },
                {
                    id:7,
                    caption: 'International Payments',
                    iconName: "globe",
                },
                {
                    id:8,
                    caption: 'Inter-group Transfers',
                    iconName: "bank",
                }]
            },
            {
                id:4,
                caption: 'XML templates',
                iconName: "table",
                subItems: [{
                    id:1,
                    caption: 'Bacs Payments',
                    iconName: "money",
                },
                {
                    id:2,
                    caption: 'Faster Payments',
                    iconName: "flash",
                },
                {
                    id:3,
                    caption: 'CHAPS Payments',
                    iconName: "credit-card-alt",
                },
                {
                    id:4,
                    caption: 'SEPA Credit Transfers',
                    iconName: "credit-card",
                },
                {
                    id:5,
                    caption: 'International Payments',
                    iconName: "globe",
                },
                {
                    id:6,
                    caption: 'Inter-group Transfers',
                    iconName: "bank",
                }]
            },
            {
                id:5,
                caption: 'XML example files',
                iconName: "upload",
                subItems: [{
                    id:1,
                    caption: 'Bacs Payments (SDSC)',
                    iconName: "money",
                },
                {
                    id:2,
                    caption: 'Multiple Bacs Payments (SDMC)',
                    iconName: "exchange",
                },
                {
                    id:3,
                    caption: 'Faster Payments (SDSC)',
                    iconName: "flash",
                },
                {
                    id:4,
                    caption: 'Multiple Faster Payments (SDMC)',
                    iconName: "play-circle",
                },
                {
                    id:5,
                    caption: 'CHAPS Payments',
                    iconName: "credit-card-alt",
                },
                {
                    id:6,
                    caption: 'SEPA Credit Transfers',
                    iconName: "credit-card",
                },
                {
                    id:7,
                    caption: 'International Payments',
                    iconName: "globe",
                },
                {
                    id:8,
                    caption: 'Inter-group Transfers',
                    iconName: "bank",
                }]
            }]
        },
        {
            id:2,
            caption: 'Domestic beneficiary import',
            iconName: "laptop",
            subItems: [{
                id:1,
                caption: 'Guidance',
                iconName: "book",
            },
            {
                id:2,
                caption: 'Template',
                iconName: "credit-card",
            }]
        },
        {
            id:3,
            caption: 'International beneficiary import',
            iconName: "globe",
            subItems: [{
                id:1,
                caption: 'Guidance',
                iconName: "book",
            },
            {
                id:2,
                caption: 'Template',
                iconName: "credit-card",
            }]
        },
        {
            id:4,
            caption: 'Real account import',
            iconName: "play-circle",
            subItems: [{
                id:1,
                caption: 'Guidance',
                iconName: "book",
            },
            {
                id:2,
                caption: 'Template',
                iconName: "credit-card",
            }]
        },
        {
            id:5,
            caption: 'Virtual account import',
            iconName: "vcard",
            subItems: [{
                id:1,
                caption: 'Guidance',
                iconName: "book",
            },
            {
                id:2,
                caption: 'Template',
                iconName: "credit-card",
            }]
        },
        {
            id:6,
            caption: 'Bulk user import',
            iconName: "users",
            linkName: "bulkUserCreation"
        }]
    }, 
    {
        id:7,
        caption: 'Payment purpose codes',
        iconName: "book",
    },   
    ]
},
];

interface IItemType {
    id: number;
    caption: string;
    menuCaption?: string;
    linkName?: string;
    iconName: string;
    subItems?: Array<IItemType>;
}


// WEBPACK FOOTER //
// ./src/constants/content.ts